import { BASE_URL, PARAMETER } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IParameter, IParameterInput } from "models/parameter";

export async function getParameters(params: string = ""): Promise<IParameter[]> {
  const response = await axios.get(BASE_URL + PARAMETER + params);
  return response.data;
}

export async function addParameter(data: IParameterInput) {
  const response = await axios.post(BASE_URL + PARAMETER, data);
  return response.data;
}

export async function editParameter(data: IParameterInput, id: string) {
  const response = await axios.patch(BASE_URL + PARAMETER + "/" + id, data);
  return response.data;
}

export async function deleteParameter(id: string) {
  const response = await axios.delete(BASE_URL + PARAMETER + "/" + id);
  return response.data;
}

export const ParameterCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "value",
    numeric: false,
    disablePadding: false,
    label: "T_value",
  },
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "T_created_on",
  },
  {
    id: "updatedOn",
    numeric: false,
    disablePadding: false,
    label: "T_updated_on",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

